import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import newRequest from "../../context/newRequest";

const DatatableOpen = ({columns}) => {
    const location = useLocation();
    const path = location.pathname.split("/")[1];
    const [queryTicketId, setQueryTicketId] = useState("");
    const [pageState, setPageState] = useState({
        isLoading: false,
        data: [],
        total: 0,
        page: 1,
        pageSize: 10
    })


    useEffect(() => {
        const fetchData = async () => {
            console.log('ON')
            setPageState(old => ({ ...old, isLoading: true }))
            const response = await newRequest.get(`${path}?ticketId=${queryTicketId}&page=${pageState.page}`)
            const json = await response
            console.log(json);
            setPageState(old => ({ ...old, isLoading: false, data: json.data.data, total: json.data.paging.total_item }))
        }
        fetchData()
    }, [pageState.page, pageState.pageSize, queryTicketId])
    const handleDelete = async (ticket_id, token) => {
        try {
            setPageState(old => ({ ...old, isLoading: true}))
            console.log("Hapus data loading")
            await newRequest.delete(`/${path}/${ticket_id}` , {
                    headers: {
                        'Authorization': `$Bearer ${token}`
                    }
                }
            );
            const list = pageState.data
            setPageState(old => ({ ...old, isLoading: false, data:list.filter((item) => item.ticket_id !== ticket_id)  }));
        } catch (err) {}
    };

    const handleReset = () => {
        setQueryTicketId("");
    };

    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <Link to={`/${path}/${params.row.ticket_id}`} style={{textDecoration: "none"}}>
                            <div className="viewButton">View</div>
                        </Link>
                        <Link to={`/${path}/update/${params.row.ticket_id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Update
                            </div>
                        </Link>

                        <div
                            className="deleteButton"
                            onClick={() => handleDelete(params.row.ticket_id)}
                        >
                            Delete
                        </div>
                    </div>
                );
            },
        },
    ];
    return (
        <div className="datatable">
            <div className="datatableTitle">
                Ticket {path.toUpperCase()}

            </div>
            <div className="column-search">

                <div className="search">

                    <SearchOutlinedIcon/>
                    <input type="text"
                           placeholder="TicketId"
                           value={queryTicketId}
                           onChange={(e) => setQueryTicketId(e.target.value)}
                    />
                    <SearchOutlinedIcon/>
                </div>
                <div>
                    <button onClick={handleReset} className="reset">Reset</button>
                </div>
            </div>
            <DataGrid
                className="datagrid"
                columns={columns.concat(actionColumn)}
                autoHeight
                rows={pageState.data}
                rowCount={pageState.total}
                loading={pageState.isLoading}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                page={pageState.page - 1}
                pageSize={pageState.pageSize}
                paginationMode="server"
                onPageChange={(newPage) => {
                    setPageState(old => ({...old, page: newPage + 1}))
                }}
                onPageSizeChange={(newPageSize) => setPageState(old => ({...old, pageSize: newPageSize}))}

            />
        </div>
    );
};

export default DatatableOpen;
